import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { RESTRICTED_OPTION_PROPS, RESTRICTED_OPTION_TOOLTIP } from 'customer-data-filters-ui/utils/fieldLevelPermissions';
import { jsx as _jsx } from "react/jsx-runtime";
class FilterOperatorPropertyInputOption extends Component {
  render() {
    const _this$props = this.props,
      {
        children,
        option
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(UITooltip, {
        disabled: !option.disabled,
        placement: "right",
        title: option.icon === RESTRICTED_OPTION_PROPS.icon ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: RESTRICTED_OPTION_TOOLTIP
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.FilterOperatorPropertyInput.titleCantCompareToItself"
        }),
        children: children
      })
    }));
  }
}
export default FilterOperatorPropertyInputOption;